import { render } from "./period-picker-years-with-periods.vue?vue&type=template&id=5d11c705"
import script from "./period-picker-years-with-periods.vue?vue&type=script&lang=js"
export * from "./period-picker-years-with-periods.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__